"use strict";
import { addEvent } from "../addEvent/addEvent";
import { isMobile } from "../isMobile/isMobile";

export const mainPageBaner = class {
  mainContainer = false;
  ulTxtContainer = false;
  imagesContainer = false;

  contentContainer = false;
  inProgress = false;
  curentElement = 0;
  elementsTxt = [];
  elementsImg = [];

  imagesContainerClass = "main-page-baner__images-container";
  contentContainerClass = "main-page-baner__show-container";
  showContainer_contentContainer = "show-container__contentContainer";

  mainContainerAnimationClass = "main-page-baner--animation";
  inAnimationClass = "main-page-baner__in-animation";
  outAnimationClass = "main-page-baner__out-animation";

  slideControlContainerClass = "main-page-baner__slides-control";
  slideControlChangeSlideButtonClass = "slides-control__change-slide";
  slideControlChangeSlidePrevButtonClass = "slides-control__change-slide--prev";
  slideControlChangeSlideNextButtonClass = "slides-control__change-slide--next";

  autoChange = true;
  autoChangeTime = 10000;
  autoChangeTimer = false;
  inAnimationTime = 1550;
  outAnimationTime = 1550;

  touchstartx = undefined;
  touchmovex = undefined;
  movex = undefined;
  longTouch = undefined;

  constructor(mainContainer) {
    if (!mainContainer) {
      return false;
    }

    this.mainContainer = mainContainer;
    this.ulTxtContainer = mainContainer.getElementsByTagName("ul")[0];

    if (!this.ulTxtContainer) {
      return false;
    }

    //this.ulImgContainer = ulImgContainer;

    this._createImgContainer();

    this._start();
    return this;
  }

  _createImgContainer = () => {
    const { mainContainer, imagesContainerClass, ulTxtContainer } = this;

    let imagesContainer = document.createElement("div");
    imagesContainer.classList.add(imagesContainerClass);

    let images = ulTxtContainer.querySelectorAll(".main-page-baner__image");

    images.forEach((elm) => {
      imagesContainer.appendChild(elm);
    });

    if (images.length > 0) this.imagesContainer = imagesContainer;

    mainContainer.appendChild(this.imagesContainer);
  };

  _start = () => {
    const { mainContainerAnimationClass, curentElement } = this;
    this.mainContainer.classList.add(mainContainerAnimationClass);
    this._addContetnContainer(this.mainContainer);
    this._setElements();
    this._createSlidesControl();
    this._displayElement(curentElement);
    this._touchInit();
  };

  _setElements = () => {
    this.elementsTxt = this.ulTxtContainer.querySelectorAll("li");
    this.elementsImg = this.imagesContainer.querySelectorAll("div");
  };

  _addContetnContainer = (parent) => {
    this.contentContainer = document.createElement("div");
    this.contentContainer.classList.add(this.contentContainerClass);
    parent.prepend(this.contentContainer);
  };

  _createSlidesControl = () => {
    const {
      mainContainer,
      curentElement,
      elementsTxt,
      elementsImg,
      slideControlContainerClass,
      slideControlChangeSlideButtonClass,
      slideControlChangeSlidePrevButtonClass,
      slideControlChangeSlideNextButtonClass,
      _slidesPrevNextControlClick,
    } = this;

    if (elementsTxt.length < 2) {
      return;
    }

    let controlContainer = document.createElement("div");
    controlContainer.classList.add(slideControlContainerClass);

    const prevSlideButton = document.createElement("div");
    prevSlideButton.classList.add(slideControlChangeSlideButtonClass);
    prevSlideButton.classList.add(slideControlChangeSlidePrevButtonClass);
    _slidesPrevNextControlClick(prevSlideButton, -1);

    controlContainer.insertBefore(prevSlideButton, controlContainer.firstChild);

    let nextSlideButton = document.createElement("div");
    nextSlideButton.classList.add(slideControlChangeSlideButtonClass);
    nextSlideButton.classList.add(slideControlChangeSlideNextButtonClass);
    _slidesPrevNextControlClick(nextSlideButton, 1);
    controlContainer.appendChild(nextSlideButton);

    mainContainer.appendChild(controlContainer);
  };

  _slidesPrevNextControlClick = (clikcElement, step) => {
    addEvent(clikcElement, "click", (e) => {
      const { elementsTxt, inProgress, _displayElement, _setInProgress } = this;

      if (inProgress) {
        return;
      }
      _setInProgress();

      let elementToShow = this.curentElement + step;
      if (elementToShow < 0) {
        elementToShow = elementsTxt.length - 1;
      }
      if (elementToShow >= elementsTxt.length) {
        elementToShow = 0;
      }

      _displayElement(elementToShow);
    });
  };

  _displayElement = (idx) => {
    this.elementsTxt[this.curentElement].classList.remove(
      this.inAnimationClass
    );
    this.elementsTxt[this.curentElement].classList.add(this.outAnimationClass);
    this.elementsImg[this.curentElement].classList.remove(
      this.inAnimationClass
    );
    this.elementsImg[this.curentElement].classList.add(this.outAnimationClass);

    setTimeout(() => {
      this.elementsTxt[this.curentElement].classList.remove(
        this.outAnimationClass
      );
      this.elementsImg[this.curentElement].classList.remove(
        this.outAnimationClass
      );
    }, this.outAnimationTime);

    this.elementsTxt[idx].classList.remove(this.outAnimationClass);
    this.elementsTxt[idx].classList.add(this.inAnimationClass);
    this.elementsImg[idx].classList.remove(this.outAnimationClass);
    this.elementsImg[idx].classList.add(this.inAnimationClass);

    let elm = this.elementsTxt[idx]
      .getElementsByClassName("main-page-baner__content")[0]
      .cloneNode(true);

    let row_1 = elm.getElementsByClassName("row__one")[0];
    if (row_1) {
      this._wrapElement(row_1, "span", "span-wraper");
    }

    let row_2 = elm.getElementsByClassName("row__two")[0];
    if (row_2) {
      this._wrapElement(row_2, "span", "span-wraper");
    }

    let row_3 = elm.getElementsByClassName("row__three")[0];
    if (row_3) {
      this._wrapElement(row_3, "span", "span-wraper");
    }

    let info = elm.getElementsByClassName("main-page-baner__more-info")[0];
    if (info) {
      this._wrapElement(info, "div", "span-wraper");
    }
    /*
    let link = info.getElementsByClassName("main-page-baner__button");
    if (link.length > 0) {
      link = link[0];
      let fullBanerLink = document.createElement("a");
      fullBanerLink.classList.add("main-page-baner__button--full");
      fullBanerLink.href = link.href;
      elm.appendChild(fullBanerLink);
    }
*/
    let wrapper = document.createElement("div");
    wrapper.classList.add(this.showContainer_contentContainer);
    wrapper.classList.add(this.inAnimationClass);
    wrapper.appendChild(elm);
    /*
    this.contentContainer.style.height =
      this.contentContainer.offsetHeight != 0
        ? `${this.contentContainer.offsetHeight}px`
        : "auto";
*/
    if (this.contentContainer.lastChild) {
      this.contentContainer.lastChild.classList.remove(this.inAnimationClass);
      this.contentContainer.lastChild.classList.add(this.outAnimationClass);
      setTimeout(() => {
        this.contentContainer.firstChild.remove();
      }, this.outAnimationTime);
    }

    this.contentContainer.appendChild(wrapper);

    //this.contentContainer.style.height =  wrapper.offsetHeight != 0 ? `${wrapper.offsetHeight}px` : "auto";

    setTimeout(
      () => {
        this.curentElement = idx;
        this._startTimer();
      },
      this.outAnimationTime > this.inAnimationTime
        ? this.outAnimationTime
        : this.inAnimationTime
    );
  };

  _setInProgress = () => {
    let { inProgress, outAnimationTime, inAnimationTime } = this;

    if (inProgress === false) {
      this.inProgress = true;

      setTimeout(
        () => {
          this.inProgress = false;
        },
        outAnimationTime > inAnimationTime ? outAnimationTime : inAnimationTime
      );
    }
  };

  _startTimer = () => {
    let { autoChange, autoChangeTime, autoChangeTimer, _changeSlideTimer } =
      this;

    if (!autoChange) {
      return;
    }
    clearTimeout(this.autoChangeTimer);
    this.autoChangeTimer = setTimeout(() => {
      _changeSlideTimer();
    }, autoChangeTime);
  };

  _changeSlideTimer = () => {
    const {
      elementsTxt,
      inProgress,
      _displayElement,
      _setInProgress,
      _startTimer,
      autoChangeTimer,
    } = this;
    const step = 1;

    if (inProgress) {
      return;
    }
    _setInProgress();

    let elementToShow = this.curentElement + step;
    if (elementToShow < 0) {
      elementToShow = elements.length - 1;
    }
    if (elementToShow >= elementsTxt.length) {
      elementToShow = 0;
    }

    _displayElement(elementToShow);

    setTimeout(
      () => {
        this._startTimer();
      },
      this.outAnimationTime > this.inAnimationTime
        ? this.outAnimationTime
        : this.inAnimationTime
    );
  };

  _wrapElement = (elm, htmlWraper, className) => {
    let wrapper = document.createElement(htmlWraper);
    if (className) {
      wrapper.classList.add(className);
    }
    elm.parentNode.appendChild(wrapper);
    wrapper.appendChild(elm);
  };

  _touchInit = () => {
    const { mainContainer, _touchChangeSlide } = this;

    mainContainer.addEventListener(
      "touchstart",
      (e) => {
        this.touchstartx = e.changedTouches[0].pageX;

        this.longTouch = false;
        setTimeout(() => {
          this.longTouch = true;
        }, 50);
      },
      { passive: true }
    );

    mainContainer.addEventListener(
      "touchmove",
      (e) => {
        this.touchmovex = e.changedTouches[0].pageX;
      },
      { passive: true }
    );

    mainContainer.addEventListener(
      "touchend",
      (e) => {
        this.movex = this.touchstartx - this.touchmovex;

        if (this.longTouch && this.movex > 50) {
          _touchChangeSlide(1);
        }

        if (this.longTouch && this.movex < -50) {
          _touchChangeSlide(-1);
        }
      },
      { passive: true }
    );
  };

  _touchChangeSlide = (step) => {
    const { elementsTxt, inProgress, _displayElement, _setInProgress } = this;

    if (inProgress) {
      return;
    }
    _setInProgress();

    let elementToShow = this.curentElement + step;
    if (elementToShow < 0) {
      elementToShow = elementsTxt.length - 1;
    }
    if (elementToShow >= elementsTxt.length) {
      elementToShow = 0;
    }

    _displayElement(elementToShow);
  };
};
